(function() {
    'use strict';
    angular
        .module('valueconnectApp')
        .factory('NationalBrokerage', NationalBrokerage);

    NationalBrokerage.$inject = ['$resource'];

    function NationalBrokerage ($resource) {
        var resourceUrl =  'api/national-brokerages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
